import { render, staticRenderFns } from "./CreateProjectAdminComponent.vue?vue&type=template&id=3a7f1812"
import script from "./CreateProjectAdminComponent.vue?vue&type=script&lang=js"
export * from "./CreateProjectAdminComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports